import { SvgIcon, SvgIconProps } from "@sol/uikit/core/icons/SvgIcon";

export const Edit02 = (props: SvgIconProps) => {
    return (
        <SvgIcon {...props} width="24" height="24" viewBox="0 0 24 24">
            <g id="edit-02">
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M14.7248 4.09319C15.5835 3.23397 16.9761 3.23339 17.8356 4.09188L19.906 6.15996C20.7658 7.0188 20.7664 8.41211 19.9073 9.27168L10.1336 19.0507C9.82722 19.3573 9.43706 19.5665 9.01213 19.6522L4.64615 20.5319C4.31778 20.598 3.9781 20.4954 3.74131 20.2585C3.50453 20.0216 3.40209 19.6818 3.46844 19.3535L4.34974 14.9926C4.43544 14.5686 4.64426 14.1792 4.95009 13.8732L14.7248 4.09319ZM16.4222 5.50689C16.344 5.42885 16.2174 5.4289 16.1394 5.50701L14.7792 6.86797L17.1313 9.22006L18.4927 7.85785C18.5708 7.77971 18.5708 7.65305 18.4926 7.57497L16.4222 5.50689ZM15.7174 10.6347L13.3653 8.28258L6.36469 15.2871C6.33689 15.3149 6.3179 15.3503 6.31011 15.3888L5.72706 18.2739L8.61709 17.6916C8.65571 17.6838 8.69118 17.6648 8.71904 17.6369L15.7174 10.6347Z"
                    className="fill-current"
                />
            </g>
        </SvgIcon>
    );
};
